import blacklist from '@/http/requests/blacklist'

export default {
  fetchBlacklist ({ commit }, data) {
    return new Promise((resolve, reject) => {
      blacklist.list(data)
        .then(res => {     
          if (data.page > 1) {
            commit('UPDATE_BLACKLIST', res.data.data)
          } else {
            commit('SET_BLACKLIST', res.data.data)
          }
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
